import { render, staticRenderFns } from "./UserEditPhones.vue?vue&type=template&id=4deec284&"
import script from "./UserEditPhones.vue?vue&type=script&lang=js&"
export * from "./UserEditPhones.vue?vue&type=script&lang=js&"
import style0 from "./UserEditPhones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports